// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"634":"a69eee52c7b08f3a","735":"b0423fcc837daf14","937":"5f642cba646c71d0"}[chunkId] + ".js";
};